import { StateMenu } from "./mixins/globalMixin";

export default {
  state: {
    loadingCount: 0,
    msgAlert: "",
    drawer: StateMenu.mini,
    globalNotification: {
      show: false,
      message: "",
      type: "info",
      persistent: false,
      dismissible: true,
      actions: [] as Array<{
        label: string;
        action: () => void;
        color?: string;
        variant?: string;
        icon?: string;
      }>,
    },
  },
  startLoader() {
    this.state.loadingCount++;
  },
  stopLoader() {
    this.state.loadingCount--;

    if (this.state.loadingCount <= 0) {
      this.state.loadingCount = 0;
    }
  },
  setMsgAlert(msg: string) {
    this.state.msgAlert = msg;
  },

  showGlobalNotification(notification: {
    message: string;
    type?: string;
    persistent?: boolean;
    dismissible?: boolean;
    actions?: Array<{
      label: string;
      action: () => void;
      color?: string;
      variant?: string;
      icon?: string;
    }>;
  }) {
    this.state.globalNotification = {
      show: true,
      message: notification.message,
      type: notification.type || "info",
      persistent: notification.persistent || false,
      dismissible: notification.dismissible !== false,
      actions: notification.actions || [],
    };
  },

  hideGlobalNotification() {
    this.state.globalNotification.show = false;
  },
};
